import MobileLobby from ".";

import { fetchResultHistory, tempDataPage, checkFetchStatus, fillRoadmapText, initUserdata } from "@/modules/commonMobile";
import fillRoadmapFilters from "@/modules/fillRoadmapFilters";
import { getBasePcode, getBasePcodes, getGroupCode, getGroupDict } from "@/modules/gamePcode";
import { fetchLanguageData } from "@/modules/locales";
import { fetchFavourites } from "@/modules/onlyLobbyMethods";
import { setSettingProperties } from "@/modules/settings";
import { emitLobbyConnect } from "@/modules/sockets";
import { fetchTransactionHistory, toggleTransactionDetail } from "@/modules/transactions";

import { IGameObjectType, IUserdataType } from "@/types/GlobalTypes";
import { getFastTableGames } from "../Desktop/fetchMethods";
import { groupPcodesByCategory } from "../Desktop/fragments";

// Todo: refactor this file

export function fetchGameList(this: MobileLobby, paramObj) {
	const mobileGame = this;
	mobileGame.fetchResultHistory = fetchResultHistory;
	mobileGame.fetchTransactionHistory = fetchTransactionHistory;
	mobileGame.toggleTransactionDetail = toggleTransactionDetail;

	const request = this.state.useTempData ?
		new Request(tempDataPage + "?page=games") :
		new Request("/games");

	let init: RequestInit;
	if (!this.state.useTempData)
		init = { credentials: "same-origin" };

	//Fetch game list
	fetch(request, init)
		.then(res => res.json())
		.catch(error => {
			return console.error(error);
		})
		.then(games => {
			if (!this.state.useTempData)
				checkFetchStatus(games);

			const
				gamePcodes = Object.keys(games),
				uniqueGamePcodes = getBasePcodes(gamePcodes),
				gameGroups = getGroupDict(gamePcodes);

			this.categoryCache = groupPcodesByCategory(games);

			// console.log("Unique pcodes: ", uniqueGamePcodes);
			// console.log("Groups: ", gameGroups);

			const fastTableGames = getFastTableGames(games);

			//Fills roadmap filters
			fillRoadmapFilters(games);

			//Init modal and roadmap
			for (const pcode in games) {
				const game = games[pcode];

				if (game.roadmapFilters)
					game.activeRoadmapFilter = game.roadmapFilters[0];
				else game.roadmapFilters = [];
			}

			if (paramObj.firstTime)
				this.fetchGameTime(games);

			//Sets activeGame (since there"s no activeGame here
			const gameArray = Object.keys(games);
			this.activePcode = gameArray[gameArray.length - 1];

			this.setState(
				{
					games,

					activeGame: games[gameArray[gameArray.length - 1]],

					uniqueGamePcodes,
					gameGroups,
					fastTableGames
				}, function () {
					//Sets lobby game filter to default
					this.setLobbyGameFilter();

					//Fetches game history
					this.fetchGameHistory();

					this.checkGameGroup();

					window.setTimeout(() => {
						fillRoadmapText(games, mobileGame.state.lang);
						mobileGame.setState({ games: games });
					}, 2500);

					// Fetches transaction history
					mobileGame.fetchTransactionHistory();
					mobileGame.allowRefetchTransaction = true;
				}
			);
		});
}

export function fetchGameTime(this: MobileLobby, gamedata: IGameObjectType) {
	if (this.state.useTempData) {
		const data = gamedata || this.state.games;
		// console.log("fetchGameTime()", data);
		const _games = JSON.parse(JSON.stringify(data));

		//fills games with random time
		let t = 0;
		for (const a in _games) {
			t = Math.round(Math.random() * 30);

			// t = 20
			// _games[a] = { time: t < 10 ? (this.state.lang ? this.state.lang["txt_bet_closed"] : "BET CLOSED") : t, timer: 60 };

			// Test toto macau
			_games[a] = (a === "m17")
				? {
					time: 8000,
					timer: 6000
				} : {
					time: t < 10
						? (this.state.lang
							? this.state.lang["txt_bet_closed"]
							: "BET CLOSED"
						) : t,
					timer: 60
				};
		}
		this.setState({ timers: _games });

		const mobileLobby = this;

		if (!this.timerTimer && !this.addedTimers)
			this.timerTimer = window.setTimeout(() => {
				//Init timers
				if (mobileLobby.state.enableTimers) {
					mobileLobby.intervalUserData = window.setInterval(() => mobileLobby.fetchUserData(null), 30000);
					mobileLobby.intervalGameTime = window.setInterval(mobileLobby.decrementGameTimers, 1000, mobileLobby);

					mobileLobby.addedTimers = true;
				}
			}, 1000, () => console.log("Empty callback"));

		return;
	}

	fetch("/games/timer", {
		credentials: "same-origin",
		method: "GET",
	})
		.then(res => res.json())
		.then(data => {
			// for (const pcode in data) {
			// 	data[pcode].time = (
			// 		isNaN(data[pcode].time) ? 0 : Number(data[pcode].time)
			// 	);
			// }

			this.setState({ timers: data });

			const mobileLobby = this;

			if (!this.timerTimer)
				this.timerTimer = window.setTimeout(() => {
					//Init timers
					if (mobileLobby.state.enableTimers) {
						mobileLobby.intervalUserData = window.setInterval(() => mobileLobby.fetchUserData(null), 30000);
						mobileLobby.intervalGameTime = window.setInterval(mobileLobby.decrementGameTimers, 1000, mobileLobby);
					}
				}, 1000, () => console.log("Empty callback"));
		});
}


export function fetchUserData(paramObj: { firstTime?: boolean }) {
	// This will prevent server overloading just because the overblasting of the Socket event isn't fixed yet
	if (!this.allowFetchUserData)
		return;

	this.allowFetchUserData = false;
	window.setTimeout(() => {
		this.allowFetchUserData = true;
	}, 1000);


	const lobby = this;
	const { useTempData } = this.state;
	const request = useTempData ?
		new Request(tempDataPage + "?page=userdata") :
		new Request("/auth/datapost");

	let init = null;
	if (!useTempData)
		init = {
			credentials: "same-origin",
			method: "POST",
			body: JSON.stringify({ test: "this is a test" })
		};

	//Fetch user data
	fetch(request, init)
		.then(res => res.json())
		.then((rawUserdata: IUserdataType) => {
			if (!useTempData)
				checkFetchStatus(rawUserdata);

			const userdata = rawUserdata;

			initUserdata(userdata);

			//initialises Socket IO
			if (!this.socketio)
				this.initSocketIO(userdata);

			this.setState({ userdata });

			if (paramObj && paramObj.firstTime) {
				setSettingProperties(this, userdata);
				fetchLanguageData(this, userdata.user.lang);
				fetchFavourites(this);

				this.fetchSoundVolumes();

				if (useTempData)
					emitLobbyConnect(lobby, lobby.state.userdata);
			}

			if (!lobby.hasEmittedLobbyConnect)
				emitLobbyConnect(lobby, userdata);
		})
		.catch(error => {
			this.setState({
				showErrorPage: true, errorType: "lostauth", errorMessage: ""
			});
			
			return console.error(error);
		});
}

export function fetchSoundVolumes(this: MobileLobby) {
	const mobileLobby = this;

	const request = (this.state.useTempData) ?
		new Request(tempDataPage + "?page=setting-volume") :
		new Request("/auth/setting-volume");

	let init: RequestInit;
	if (!this.state.useTempData)
		init = {
			credentials: "same-origin",
			method: "GET",
		};

	fetch(request, init)
		.then(res => res.json())
		.catch(error => {
			this.setState({
				showErrorPage: true,
				errorType: "lostauth",
				errorMessage: ""
			});
			return console.error(error);
		})
		.then(data => {
			// console.log("fSV dat", data);

			this.setState({
				musicVolume: isNaN(data.volumeMusic) ? 50 : (Number(data.volumeMusic) * 100),
				soundVolume: isNaN(data.volumeSound) ? 50 : (Number(data.volumeSound) * 100)
			}, () => {
				mobileLobby.bgmLobby.volume = mobileLobby.state.musicVolume / 100;
			});
		});
}
